"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const toolbox_ab_testing_1 = require("@zapier/toolbox-ab-testing");
const shouldUseBanditOptimization_1 = __importDefault(require("../utils/shouldUseBanditOptimization"));
function useBanditOptimizationByFeature(featureName, opts = { shouldSkip: false }) {
    const { isSwitchOn: isOptedIn } = toolbox_ab_testing_1.useSwitch(`Editor-Enable_${featureName}-Opt_In`);
    const { isSwitchOn: isOptedOut } = toolbox_ab_testing_1.useSwitch(`Editor-Enable_${featureName}-Opt_Out`);
    const { isSwitchOn: isForcedOn } = toolbox_ab_testing_1.useSwitch(`Editor-Enable_${featureName}-Force_On`);
    const shouldUseBandit = !opts.shouldSkip &&
        shouldUseBanditOptimization_1.default(isOptedIn, isOptedOut, isForcedOn);
    const banditConfig = {
        name: `Editor-Enable_${featureName}_v2`,
        options: ['control', 'experiment'],
    };
    const banditOptions = {
        shouldSkip: !shouldUseBandit,
    };
    const { isLoading: isBanditLoading, result } = toolbox_ab_testing_1.useBandit(banditConfig, banditOptions);
    const showBanditExperiment = shouldUseBandit && lodash_1.get(result, ['recommendation', 0]) === 'experiment';
    return {
        isBanditLoading,
        shouldShowBanditExperiment: showBanditExperiment || isForcedOn,
    };
}
exports.default = useBanditOptimizationByFeature;
